import { render, staticRenderFns } from "./ProductMarkupPicker.vue?vue&type=template&id=dd2c4f1a&scoped=true&"
import script from "./ProductMarkupPicker.vue?vue&type=script&lang=js&"
export * from "./ProductMarkupPicker.vue?vue&type=script&lang=js&"
import style0 from "./ProductMarkupPicker.vue?vue&type=style&index=0&id=dd2c4f1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2c4f1a",
  null
  
)

export default component.exports